
/**
 * Note: context is FV library.
 * extendJQuery
 * - for $.fn.ajaxError
 * - could refactor so this is a module -- though now import not really necessary ( $ namespace will have been loaded )
 * - can reference directly $.fn for now
 */


var DocumentLockStatus = require('./documentLockStatus');


require('extendJQuery');


var commands = {

    /** -- Not necessary, only if using EQ master branch; no selectors --
    initElementQuery: function() { //would only need in wanted to print them
        this.eq.init();
    },
    */

    updateElementQuery: function() {
        return this.EQ.elementQuery.refresh();
    },
    // Redundant on here ... just store these on this .. subapp or mixin ...
    userLoggedOut: function() {
        this._enterLoggedOutMode.apply(this, arguments);
    },
    unauthorizedLogout: function() {
        this._enterLoggedOutMode();
    },
    userLogoutError: function(jqXHR) {  //todo: would the error here be on all viewers?
        this.request('firstViewerInstance').command('ajaxError', jqXHR);
    },
    userLoggedIn: function(options) {
        this.triggerMethod('userLogin', options);
    },
    viewerDestroyed: function(viewer) { /* cb post deletion of instance */
        this.viewers = _.omit(this.viewers, String(viewer.id));
        this.numberViewers--; /* prevent resize if none exist */
        viewer = null; //its still around ...
        //todo: any need to update the ids of the others?
    },

    /**
     * TODO:
     * - this is temp: for now send to the first viewer (if multi, don't know which one) ...
     * -   have one on the window object and use body?
     * - Diff method to handle errors if the first instance isn't yet created -- if not now will go to console
     */
    updatePostRunTimeError: function(msg, url, line) {

        var firstViewer = this.channel.request('firstViewerInstance');

        firstViewer && firstViewer.trigger( 'alert:show', {
            type: 'error',
            shortMessage: 'Error',
            detailedMsg:  msg +  " url: " + url + " line #: " + line
        });

        _.invoke(this.viewers, 'command', 'updatePostRunTimeError');
    }



};

var requests = {

    /**
     * Wrapper around $.fn.ajaxErrorMessage taking into account document locking
     * By convention, 409 will be returned as an error in responses that fail
     * because the document is locked by another user.
     * Here, the response body will be a documentLockStatus model
     * (the same returned from document lock webservices -- lock, unlock, status).
     * Show the same message shown elsewhere for the blocking of transactions due to document locks.
     * Transactions may be blocked on entry and this is often a double check.
     * Leave $.fn.ajaxErrorMessage as generic fn, especially b/c could be used by FT Widget.
     * Can still call $.fn.ajaxErrorMessage if sure not checking for a document lock -- though may want to search
     * for all reference and refactor to filter them through here.
     * Could combo logic 'vChannel.command('showDocumentLockedErrorAlert')'
     */
    ajaxErrorMessage: function( jqXHR ) {

        var isDocumentLockError = jqXHR.status === 409;

        return isDocumentLockError

            ? new DocumentLockStatus( jqXHR.responseJSON ).getDefaultErrorMessage()
            : $.fn.ajaxErrorMessage( jqXHR );

    },

    options: function() {
        return this.options;
    },
    settings: function() {
        return this.settings; //issue -- this not defined yet to return the value?
    },
    localStorage: function() {
        return this.localStorageSettings;
    },
    user: function() {
        return this.user; //can i require from it?
    },
    auth: function() {
        return this.auth;
    },
    isAuthenticated: function() {
      return this.auth.isAuthenticated();
    },
    apiUrl: function() {
        return this.apiURL;
    },
    reasonCodes: function() {
        return this.reasonCodes;
    },
    versionModel: function() {
        return this.version;
    },
    cssConstants: function() {
        return this.cssConstants;
    },
    firstViewerInstance: function() {
        return this.firstViewerInstance();
    },
    esURL: function() {
        return this.settings.absolutePathToES;
    },
    allowFlashNotes: function() {
        var sysPolicies = this.systemPolicies;
        return sysPolicies && sysPolicies.allowFlashNotes();
    },
    supportConsults: function() {
        var sysPolicies = this.systemPolicies;
        return sysPolicies && sysPolicies.allowConsults();
    },
    applyFloatingReasonCodes: function() {
        var sysPolicies = this.systemPolicies;
        return sysPolicies && sysPolicies.applyFloatingReasonCodes();
    },

    getPageNoteTitleMaxLength: function() {

        return this.systemPolicies.getPageNoteTitleMaxLength();

    },
    constants: function() {
        return this.constants;
    }



};


module.exports = {
    commands: commands,
    requests: requests
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/channel.js
 ** module id = 765
 ** module chunks = 0
 **/